/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import TaskProgressView from '@bingads-webui-static-legacy/uet/view/uploadConversions/taskProgress';
import StatusPoller from '@bingads-webui-static-legacy/uet/view/uploadConversions/statusPoller';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var Task = function (options) {
  this.options = options || ({});
  instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/UploadConversions/pollerTask', 'ExecutionId passed in: ' + this.options.ExecutionId);
  this.view = new TaskProgressView({
    model: {
      statusText: this.options.statusText,
      completeText: this.options.completeText
    },
    task: this
  });
  this.poller = new StatusPoller({
    ExecutionId: this.options.ExecutionId,
    parentTask: this
  });
};
Task.prototype.run = function () {
  this.poller.start();
};
_.extend(Task.prototype, backbone.Events);
export default Task;

